import '../App.css';
import 'animate.css';



function Resume() {
  
  return (
    <div className="App">
      <div className="home-container">
      <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>
        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <a href="/">
          <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">← return home</h5>
        </a>
        <h1 className="animate__animated animate__fadeInUp animate__slow">resume</h1>
        <p className="animate__animated animate__fadeIn animate__slow animate__delay-2s">Last Updated: May 21st, 2021</p>
        
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-2s">
          <h3>
           Experience:
          </h3>
          <h2>
            <li>Citygate Church, Software and Network Engineer – Contract</li>
            <li>Rettich Productions, Software Developer – Freelance Project</li>
            <li>
              <a href="https://mcknight.digital">McKnight Digital</a>, Software Developer – Consultant
            </li>
            <li>Rasnick Fitness, Web Developer and Designer – Freelance Project</li>
          </h2>
        </div>
        <div className="about">
          <h3>
           Education:
          </h3>
          <h2>
            <li class="grey">Wright State University, Bachelor's in Computer Science (2025)</li>
            <li>Sinclair Community College, Associates in Computer Science (2022)</li>
            <li>edX, Harvard CS50 Certification (2018)</li>
            <li>Cincinnati State, Web Development (2018)</li>
            <li>Butler Tech, Digital Media Productions (2016)</li>
            <li>Monroe High School (2016)</li>
          </h2>
        </div>
        <div className="about">
          <h3>
           Skills:
          </h3>
          <h2>
            <li>Software Development using C++, C#, JavaScript, and Python.</li>
            <li>Web Development using React, HTML, CSS, and the .NET Framework</li>
            <li>Progressive Mobile Apps using Ionic Framework</li>
            <li>Native Mobile Development using Swift and or Flutter</li>
            <li>Communication using e-mail, Slack, Phone Calls, smoke signals? I know how to communicate. I'm also an native English speaker.</li>
          </h2>
        </div>
      
        <h3>Learn More on: <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/adammcknight/">LinkedIn.com/adammcknight</a></h3>
       
        <h5 className="grey home-link">view privacy and site license —</h5>
      </div>

      
      
    </div>
  );
}

export default Resume;
